var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.685547 7.43294C0.685547 8.14367 0.990933 8.77869 1.47227 9.20684V5.66034C0.990933 6.08729 0.685547 6.72301 0.685547 7.43294ZM2.30442 5.19379V9.67239C2.50088 9.72984 2.70839 9.76228 2.92202 9.76228H3.13673V5.11491C3.06509 5.10866 2.99346 5.10439 2.92073 5.10439C2.70641 5.10439 2.50021 5.13595 2.30442 5.19379ZM4.14245 5.48451C4.08559 5.44602 4.02894 5.41069 3.96851 5.37785V9.76228H4.80039V3.89785C4.46919 4.35546 4.2384 4.89573 4.14245 5.48451ZM5.63277 3.07332V9.76228H6.46494V2.63952C6.16748 2.74549 5.88836 2.89303 5.63277 3.07332ZM7.29682 2.45715V9.76228H8.129V2.48403C7.95854 2.45715 7.78301 2.44316 7.60421 2.44316C7.50013 2.44316 7.39763 2.44851 7.29682 2.45715ZM9.41978 2.97221C9.14811 2.80174 8.8557 2.6673 8.54524 2.5776V9.76228H9.79325V2.44226C9.65702 2.60866 9.5318 2.78637 9.41978 2.97221ZM10.2098 2.00052V9.76228H18.1149V9.75196C19.7795 9.63925 20.53 8.54592 20.53 7.21168C20.53 5.80272 19.5241 4.66107 18.1701 4.66107C17.8225 4.66107 17.5364 4.73697 17.234 4.8742C17.0173 2.63713 15.2252 0.890625 13.0182 0.890625C11.9386 0.890625 10.9574 1.30924 10.2098 2.00052Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.4f0460bed51653045e5127cc03dfa7a8.svg";
export { ForwardRef as ReactComponent };